import { I18n } from "i18n-js";

import en from "config/locale/en";

const i18n = new I18n({ en });

export default i18n;
